import React from 'react';
import { AlertTriangle, Clock, AlertCircle, CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export interface PriorityItem {
  id: string;
  type: 'danger' | 'warning' | 'info' | 'success';
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
interface PriorityWidgetProps {
  items: PriorityItem[];
  className?: string;
}
export function PriorityWidget({
  items,
  className = ''
}: PriorityWidgetProps) {
  if (items.length === 0) return null;
  const getIcon = (type: string) => {
    switch (type) {
      case 'danger':
        return <AlertCircle className="h-5 w-5 text-red-500" data-id="element-492" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-500" data-id="element-493" />;
      case 'success':
        return <CheckCircle2 className="h-5 w-5 text-green-500" data-id="element-494" />;
      default:
        return <Clock className="h-5 w-5 text-blue-500" data-id="element-495" />;
    }
  };
  const getBgColor = (type: string) => {
    switch (type) {
      case 'danger':
        return 'bg-red-50 border-red-100';
      case 'warning':
        return 'bg-yellow-50 border-yellow-100';
      case 'success':
        return 'bg-green-50 border-green-100';
      default:
        return 'bg-blue-50 border-blue-100';
    }
  };
  return <div className={`space-y-3 ${className}`} data-id="element-496">
      <h3 className="text-sm font-bold text-seform-navy uppercase tracking-wider flex items-center gap-2" data-id="element-497">
        <AlertTriangle className="h-4 w-4 text-seform-orange" data-id="element-498" />
        Priorità e Alert
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-499">
        {items.map(item => <div key={item.id} className={`p-4 rounded-xl border ${getBgColor(item.type)} flex flex-col justify-between transition-all hover:shadow-md`} data-id="element-500">
            <div className="flex items-start gap-3 mb-3" data-id="element-501">
              <div className="mt-0.5 flex-shrink-0" data-id="element-502">{getIcon(item.type)}</div>
              <div data-id="element-503">
                <h4 className="font-bold text-slate-800 text-sm" data-id="element-504">
                  {item.title}
                </h4>
                <p className="text-xs text-slate-600 mt-1 leading-relaxed" data-id="element-505">
                  {item.description}
                </p>
              </div>
            </div>
            {item.actionLabel && <div className="flex justify-end mt-auto pt-2" data-id="element-506">
                <Button size="sm" variant="ghost" className="!px-2 !py-1 h-auto text-xs" onClick={item.onAction} endContent={<ArrowRight className="h-3 w-3" data-id="element-508" />} data-id="element-507">
                  {item.actionLabel}
                </Button>
              </div>}
          </div>)}
      </div>
    </div>;
}